<template>
    <span class="CheckboxEditor">
        <span v-if="CheckPermission(ViewPermissionRequirement)">
            {{ OldValueText }}
            <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
            <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer>
                <b-container>
                    <b-form @submit="Save">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    
                                    <b-form-checkbox-group stacked v-model="NewValue"
                                                           :options="Options"
                                                           size="lg">

                                    </b-form-checkbox-group>
                                    <!--<select v-if="OptionsGroupName == null" class="form-control" v-model="NewValue" v-bind:required="Required">
                                        <option v-for="option in Options" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>-->
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="Cancel()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>

                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
        <span v-else>
            PRIVATE
        </span>
    </span>

</template>

<script>

    export default {
        props: [
            "OldValue",
            "OldValueText",
            "PropertyName",
            "RecordId",
            "RecordIdName",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "Options",
            "EditPermission",
            "ViewPermissionRequirement",
            "ChartId",
            "HttpMethod",
            "AdditionalPayload",
            "ChartUpdateOnly"
        ],
        data: function () {
            return {
                NewValue: {}
            };
        },
        methods: {
            ShowEditModal() {
                this.NewValue = (this.OldValue != null) ? this.OldValue.split(",") : [];
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                let arrayCondensed = this.NewValue.join(",");
                let payload = { [this.RecordIdName === undefined ? "Id" : this.RecordIdName]: this.RecordId, [this.PropertyName]: arrayCondensed };
                if (this.AdditionalPayload != null) {
                    payload = { ...payload, ...this.AdditionalPayload };
                }
                this.$MasterAPI.ExecuteRequest(this.HttpMethod == null ? "POST" : this.HttpMethod, this.UpdateMethod, payload, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.OldValue = this.NewValue.join(",");
                this.$refs['component-modal'].hide();
                //Perform Global Updates
                if (this.ChartUpdateOnly) {
                    this.$GlobalUpdate.ExecuteChartUpdate(this.ChartId);
                } else {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
                
            },
            HandleShown() {
                //this.$refs.showfocus.focus();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            }
        }
    }
</script>

<style scoped>
</style>